import axios from 'axios';
//import { ACCESS_TOKEN_NAME } from '../../../../src/app-constants';

const defaultHeaders = {
    'Content-Type': 'application/json',
};

export const httpGet = async (
    url: string,
    customHeaders: Record<string, string> = {}
) => {
    try {
        const response = await axios.get(url, {
            headers: {
                ...defaultHeaders,
                //'Authorization': `Bearer ${getAuthToken()}`,
                ...customHeaders,
            },
        });
        return response.data;
    } catch (error) {
        console.error('HTTP GET Error:', error);
        throw error;
    }
};

export const httpPost = async (
    url: string,
    data: any,
    customHeaders: Record<string, string> = {}
) => {
    try {
        const response = await axios.post(url, data, {
            headers: {
                ...defaultHeaders,
               // 'Authorization': `Bearer ${getAuthToken()}`,
                ...customHeaders,
            },
        });
        return response;
    } catch (error) {
        console.error('HTTP POST Error:', error);
        throw error;
    }
};

export const httpPut = async (
    url: string,
    data: any,
    customHeaders: Record<string, string> = {}
) => {
    try {
        const response = await axios.put(url, data, {
            headers: {
                ...defaultHeaders,
               // 'Authorization': `Bearer ${getAuthToken()}`,
                ...customHeaders,
            },
        });
        return response;
    } catch (error) {
        console.error('HTTP PUT Error:', error);
        throw error;
    }
};

// const getAuthToken = () => {
//     const tokenString = localStorage.getItem(ACCESS_TOKEN_NAME);

//     if (tokenString) {
//         const decodedString = atob(tokenString);
//         const decodedJson = JSON.parse(decodedString);

//         return decodedJson.accessToken;
//     }

//     return null;
// } 